<script setup>
import { ref } from "vue";

const isOpen = ref(false);

const toggleMenu = () => {
  isOpen.value = !isOpen.value;
};
</script>

<template>
  <div class="header">
    <div class="usp-bar">
      <div class="usp-container">
        <div class="usp">No Contract</div>
        <div class="usp">No Credit Checks</div>
        <div class="usp d-none d-sm-block">No Price Hikes</div>
        <div class="usp d-none d-md-block">Budget SIM Only Deals</div>
      </div>
    </div>

    <div class="header-bar">
      <div class="header-container">
        <div class="logo">
          <a href="/">
            <img width="150" height="38.85" src="/images/logo1.webp" alt="Grapefroot logo" />
          </a>
        </div>
        <div class="menu-container">
          <div class="menu" @click="toggleMenu" :class="{ open: isOpen }">
            <div class="bar"></div>
            <div class="bar"></div>
            <div class="bar"></div>
          </div>
        </div>
        <div v-if="isOpen" class="header__mega-menu">
          <div class="header__mega-menu-container">
            <div class="header__mega-column mb-4">
              <h3 class="header__mega-heading"><a href="/plans">Plans</a></h3>
              <ul class="header__mega-list">
                <li v-for="(plan, index) in plans" :key="index" class="header__mega-item"><a :href="getPlanLink(plan.id)">{{ plan.name }}</a></li>
              </ul>
            </div>
            <div class="header__mega-column mb-4">
              <h3 class="header__mega-heading">About</h3>
              <ul class="header__mega-list">
                <li class="header__mega-item"><a href="/get-started">Get started</a></li>
                <li class="header__mega-item"><a :href="portalFaqsLink">FAQs</a></li>
                <li class="header__mega-item"><a href="/blog">Blogs</a></li>
              </ul>
            </div>
            <div class="header__mega-column">
              <h3 class="header__mega-heading">Customers</h3>
              <ul class="header__mega-list">
                <li class="header__mega-item"><a :href="portalLink">Log in</a></li>
                <li class="header__mega-item"><a :href="portalLink">Activate SIM</a></li>
                <li class="header__mega-item"><a href="/contact-us">Contact us</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import PlanCard from "./PlanCard.vue";
import Carousel from "vue-owl-carousel/src/Carousel";

export default {

  data() {
    return {
      plans: [],
    };
  },

  computed: {
    portalLink() {
      return process.env.VUE_APP_PORTAL_LINK;
    },
    portalFaqsLink() {
      return process.env.VUE_APP_PORTAL_LINK + "page/faqs";
    }
  },

  mounted() {
    this.fetchData();
  },

  methods: {
    fetchData() {
      axios
        .get(process.env.VUE_APP_SUPASMART_URL + "api/plans?site_id=" + process.env.VUE_APP_SITE_ID)
        .then((response) => {
          this.loading = true;
          this.plans = response.data.data;
        })

        .catch((error) => {
          this.loading = false;
          this.formStep = 1;
          console.error(error);
          if (errors.response.data.error) {
            this.serverErrors = [{ generic: errors.response.data.error }];
            return;
          }
          this.serverErrors = Object.entries(errors.response.data.errors).map((entry) => {
            return { [entry[0]]: entry[1] };
          });
          this.scrollToError();
        });
    },
    generateUniqueId() {
      return Math.random().toString(36).substring(2) + Date.now().toString(36);
    },
    getPlanLink(planId) {
      return process.env.VUE_APP_PORTAL_LINK + "order-plan/create-account?plan_id=" + planId;
    },
  },
};
</script>



<style scoped lang="scss">
.header {
  display: flex;
  justify-content: center;
  flex-direction: column;
  z-index: 5 !important;
  position: fixed;
  top: 0;
  width: 100vw;

  .usp-bar {
    display: flex;
    justify-content: center;
    background-color: var(--banana);
    color: var(--black);
    padding: 0.2rem 1rem;

    .usp-container {
      display: flex;
      justify-content: space-between;
      gap: 2rem;
      width: 100%;
      max-width: 1200px;
    }

    .usp {
      text-transform: uppercase;
      font-weight: bold;
      display: flex;
      justify-content: center;
      text-align: center;
      font-size: 0.9em;
    }
  }

  .header-bar {
    width: 100%;
    display: flex;
    justify-content: center;
    background-color: var(--black);
    color: var(--primary);

    .header-container {
      display: flex;
      justify-content: space-between;
      gap: 2rem;
      width: 100%;
      max-width: 1200px;
      padding: 0.5rem 1rem;
    }

    .logo {
      display: flex;
      align-items: center;
      font-family: "Fugaz One", sans-serif;
      font-size: 1.5rem;

      span {
        color: var(--banana);
      }

      img {
        width: 100%;
        max-width: 180px;

        @media (max-width: 640px) {
          max-width: 150px;
        }
      }
    }

    .menu-container {
      display: flex;
      justify-content: center;
      align-items: center;

      .menu {
        cursor: pointer;
        width: 25px;
        height: 20px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .bar {
          width: 100%;
          height: 2px;
          background-color: var(--primary);
          transition: transform 0.3s, opacity 0.3s;
        }

        &.open {
          justify-content: center;

          .bar:nth-child(1) {
            transform: rotate(45deg);
          }

          .bar:nth-child(2) {
            opacity: 0;
          }

          .bar:nth-child(3) {
            transform: rotate(-45deg);
            margin-top: -4px;
          }
        }
      }
    }
  }

  &__mega-menu {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    background-color: white;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
    z-index: 4;
  }

  &__mega-menu-container {
    display: flex;
    justify-content: space-around;
    padding: 2rem 1rem;
    max-width: 1200px;
    margin: 0 auto;
    flex-direction: column;
    @media only screen and (min-width: 512px) {
      flex-direction: row;
    }

  }

  &__mega-column {
    flex: 1;
    padding: 0 1rem;
  }

  &__mega-heading {
    font-size: 1.2rem;
    margin-bottom: 0.5rem;
    color: var(--black);
  }

  &__mega-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  &__mega-item {
    margin-bottom: 0.5rem;

    a {
      text-decoration: none;
      color: var(--black);
      font-size: 0.95rem;

      &:hover {
        color: var(--banana);
      }
    }
  }
}
</style>
